import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Breadcrumb, Table, Tooltip, Row, Col, Spin, Modal } from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { Collapse } from "antd";
import { getRequest, patchRequest, postRequest } from "../../axios";
import { useNavigate } from "react-router";
import CityWiseView from "./CityWiseView";
import PRPopUpDetails from "../PR/PRPopUpDetails";
import { InfoCircleOutlined } from "@ant-design/icons";
import PRPopUpDetailsForSteel from "../PR/PRPopUpDetailsForSteel";
const { Panel } = Collapse;

const RFQMaterialDetails = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { responseId } = useParams();
  const [totalWbsAmount, setTotalWbsAmount] = useState(null);
  const [siteIdAmount, setSiteIdAmount] = useState([]);
  const [RFQMaterialDetails, setRFQMaterialDetails] = useState([]);
  const [RFQMaterial, setRFQMaterial] = useState([]);
  const [rfqNumber, setRfqNumber] = useState([]);
  const [rendomId, setRendomId] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [state, setState] = useState({});
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [prNumbers, setPrNumbers] = useState([]);
  const [view, setView] = useState(null);
  const [type, setType] = useState("City Wise");
  const [am, setAm] = useState(0);
  const formRef = useRef();
  const [rfqMaterialDetailsID, setRfqMaterialDetailsID] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  const [uomList, setUOMList] = useState([]);
  const [materialDetails, setMaterialDetails] = useState([]);
  const [masterId, setMasterId] = useState(null);
  const [ifMultipleMasterId, setIfMultipleMasterId] = useState([]);
  const [aggregatedData, setAggregateData] = useState(null);
  const [prNumberList, setPRNumberList] = useState([]);
  const [statePRDetailsHover, setStatePRDetailsHover] = useState(null);
  const [prNumberHover, setPRNumberHover] = useState(null);
  const [prCreatorHover, setCreatorHover] = useState(null);
  const [tableData, setTableData] = useState({});
  const [allSiteNames, setAllSiteNames] = useState(new Set());
  const [sitedata, setSitedata] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenRfq, setIsModalOpenRfq] = useState(false);
  const [prNumberd, setPrNumberd] = useState(null);
  const [categoryId, setCategoryId] = useState(1);
  const [diameterWiseSteel, setDiameterWiseSteel] = useState(false);

  useEffect(() => {
    fetchRFQMaterialDetails();
    getCurrency();
  }, []);

  useEffect(() => {
    setMaterialDetails(RFQMaterialDetails);
  }, [RFQMaterialDetails]);

  useEffect(() => {
    if (materialDetails) {
      generateTableData(materialDetails);
    }
  }, [materialDetails]);

  const fetchRFQMaterialDetails = async () => {
    setapiLoading(true);
    try {
      const response1 = await getRequest(`float-rfq/${responseId}`);
      setType("City Wise");

      if (formRef.current) {
        formRef.current.setFieldsValue({
          pr_view: "City Wise",
        });
      }

      setCategoryId(response1.data.data.category_tree);
      setRfqNumber(response1.data.data.rfq_number);
      setPrNumberd(response1.data.data.pr_creator_name);
      setPRNumberList(
        response1.data.data.purchase_requisition_city_by_pr_number
      );

      setDiameterWiseSteel(
        response1.data.data.purchase_requisition_city_by_pr_number[0]
          .is_diameter_wise
      );
      setRFQMaterialDetails(response1.data.data);

      const masterId = response1.data.data.rfq_details[0].id;
      if (masterId) {
        setMasterId(masterId);
      }

      setView("City Wise");
      await getUnitOfMeasurement(response1.data.data.category_tree);
      const siteIdAmountsByPr = null;
      if (response1.data.data.pr_matieral_details_by_pr_number !== null) {
        const siteIdAmountsByPr =
          response1?.data?.data?.pr_matieral_details_by_pr_number.reduce(
            (acc, item) => {
              const flattenedValues = item.estimated_pr_values.flat();
              const siteAmountMap = flattenedValues.reduce((map, site) => {
                if (!map[site.pr_site_id]) {
                  map[site.pr_site_id] = {
                    id: site.pr_site_id,
                    name: site.pr_site_name,
                    amount: site.pr_site_amount,
                  };
                } else {
                  map[site.pr_site_id].amount += site.pr_site_amount;
                }
                return map;
              }, {});
              acc[item.pr_number] = Object.values(siteAmountMap);

              return acc;
            },
            {}
          );
        setSiteIdAmount(siteIdAmountsByPr);
        const flattenedData = Object.values(siteIdAmountsByPr).flat();
        setTotalWbsAmount(
          flattenedData.reduce((sum, data) => sum + data.amount, 0)
        );
      }
      setRendomId(responseId);
      const prs = response1?.data?.data?.purchase_requisition_city_by_pr_number?.map((pr) => pr.pr_number);
      setPrNumbers(prs);

      const initialState = {
        rfqId: response1.data.data.rfq_details[0].id,
        rfq_material_details: response1.data.data.material_wise_details.map(
          (material) => {
            return {
              id: material.rfq_material_id,
              material_total_quantity:
                material.material_total_quantity_by_kg / 1000,

              material_total_quantity_by_kg:
                material.material_total_quantity_by_kg,
              amount: material.amount,
              purchase_requisition_material:
                material.purchase_requisition_material_id,
              purchase_requisition_material_type_name:
                material.purchase_requisition_material_type_name,
              unit_of_measurement: material.unit_of_measurement,
              purchase_requisition_material_type_idd:
                material.purchase_requisition_material_type_id,
            };
          }
        ),
      };
      setState(initialState);

      const rfqMaterialDetails = response1?.data?.data?.rfq_material_details;

      if (
        Array.isArray(rfqMaterialDetails) &&
        rfqMaterialDetails.length === 0
      ) {
        setRfqMaterialDetailsID(false);
      } else {
        setRfqMaterialDetailsID(true);
      }
      setTotalWbsAmount(response1.data.data.rfq_total_amount);

      setapiLoading(false);
    } catch (error) {
      setapiLoading(false);
    }
  };

  const getCurrency = async (data) => {
    await getRequest(
      "business-settings/get-currency-by-business-setting/",
      data
    ).then((response) => {
      setCurrencySymbol(response.data.data);
    });
  };

  const getUnitOfMeasurement = async (cat) => {
    await getRequest(
      `get-category-by-uom/?category_tree=${cat}`
      // data
    ).then((response) => {

      const filteredData = response.data.results.data.filter(
        (item) => item.unit_of_measurement !== "KG"
      );
      setUOMList(filteredData);
    });
  };


  const generateTableData = (materialDetails) => {
  if (!materialDetails) return null;

  let allData = []; 
  const aggregatedData = {}; 
  const siteNames = new Set();
  const sitedata = []; 
  const uniqueMasterIds = new Set();

  materialDetails?.material_wise_details?.forEach((material) => {
    uniqueMasterIds.add(material.purchase_requisition_master_id);
  });

  const uniqueMasterIdsArray = Array.from(uniqueMasterIds);

  const uomConsistency = {};
  materialDetails?.material_wise_details?.forEach((material) => {
    material?.site_wise?.forEach((site) => {
      const key = `${material.purchase_requisition_material_type_name}-${site.site_name}`;
      if (!uomConsistency[key]) {
        uomConsistency[key] = new Set();
      }
      uomConsistency[key].add(material.preferred_unit_of_measurement || material.unit_of_measurement_name);
    });
  });

  materialDetails?.material_wise_details?.forEach((material) => {
    const subCategory = material.purchase_requisition_material_type_sub_category;
    const key = `${subCategory}-${material.purchase_requisition_material_type_name}`;

    if (!aggregatedData[subCategory]) {
      aggregatedData[subCategory] = {};
    }

    if (!aggregatedData[subCategory][key]) {
      aggregatedData[subCategory][key] = {
        purchase_requisition_material_type_name: material.purchase_requisition_material_type_name,
        totalQuantity: 0,
        totalAmount: 0,
        estimated_material_unit_price: material.estimated_material_unit_price,
        totalQuantityInKG: 0,
        siteWiseQuantities: {},
        unitOfMeasurement: material.unit_of_measurement_name,
        uniqueMasterIds: uniqueMasterIdsArray,
        unitOfMeasurementId: material.unit_of_measurement,
        rfq_material_id: material.rfq_material_id,
      };
    }

    material?.site_wise?.forEach((site) => {
      let adjustedQuantity = null;
      const consistencyKey = `${material.purchase_requisition_material_type_name}-${site.site_name}`;
      const hasConsistentUOM = uomConsistency[consistencyKey].size === 1;
      const preferredUOM = material.preferred_unit_of_measurement || material.unit_of_measurement_name;

      if (
        material.rfq_material_id === null &&
        uniqueMasterIdsArray.length > 1 &&
        !hasConsistentUOM
      ) {
        adjustedQuantity = calculateAdjustedQuantity(
          site.site_wise_total_quantity,
          material.unit_of_measurement_name,
          preferredUOM
        );
        aggregatedData[subCategory][key].unitOfMeasurement = preferredUOM;
        aggregatedData[subCategory][key].unitOfMeasurementId = material.preferred_unit_of_measurement_id || material.unit_of_measurement;
      } else {
        adjustedQuantity = site.site_wise_total_quantity;
        aggregatedData[subCategory][key].unitOfMeasurement = material.unit_of_measurement_name;
        aggregatedData[subCategory][key].unitOfMeasurementId = material.unit_of_measurement;
      }

      siteNames.add(site.site_name);

      if (!aggregatedData[subCategory][key].siteWiseQuantities[site.site_name]) {
        aggregatedData[subCategory][key].siteWiseQuantities[site.site_name] = {
          quantity: 0,
          uom: hasConsistentUOM ? material.unit_of_measurement_name : preferredUOM,
        };
      }

      aggregatedData[subCategory][key].siteWiseQuantities[site.site_name].quantity += adjustedQuantity;
      aggregatedData[subCategory][key].totalQuantity += adjustedQuantity;

      if (material.unit_of_measurement_name === "Cubic Meter") {
        aggregatedData[subCategory][key].totalAmount +=
          material.material_total_quantity * material.estimated_material_unit_price || 0;
      } else {
        aggregatedData[subCategory][key].totalAmount +=
          material.material_total_quantity_by_kg * material.estimated_material_unit_price || 0;
      }

      aggregatedData[subCategory][key].totalQuantityInKG += material.material_total_quantity_by_kg || 0;
    });
  });

  materialDetails?.material_wise_details?.forEach((material) => {
    const materialId = material.purchase_requisition_material_id;

    const materialData = {
      purchase_requisition_material_id: materialId,
      material_type_name: material.purchase_requisition_material_type_name,
      material_type_sub_category: material.purchase_requisition_material_type_sub_category,
      unitOfMeasurement: material.unit_of_measurement_name || material.preferred_unit_of_measurement,
      unitOfMeasurementId: material.unit_of_measurement || material.preferred_unit_of_measurement_id,
      totalQuantity: 0,
      totalAmount: 0,
      totalQuantityInKG: 0,
      siteWiseDetails: [],
      rfq_material_id: null,
    };

    material.site_wise.forEach((site) => {
      let adjustedQuantity = null;
      const consistencyKey = `${material.purchase_requisition_material_type_name}-${site.site_name}`;
      const hasConsistentUOM = uomConsistency[consistencyKey].size === 1;
      const preferredUOM = material.preferred_unit_of_measurement || material.unit_of_measurement_name;

      if (
        material.rfq_material_id === null &&
        uniqueMasterIdsArray.length > 1 &&
        !hasConsistentUOM
      ) {
        adjustedQuantity = calculateAdjustedQuantity(
          site.site_wise_total_quantity,
          material.unit_of_measurement_name,
          preferredUOM
        );
        materialData.unitOfMeasurement = preferredUOM;
        materialData.unitOfMeasurementId = material.preferred_unit_of_measurement_id || material.unit_of_measurement;
      } else {
        adjustedQuantity = site.site_wise_total_quantity;
        materialData.unitOfMeasurement = material.unit_of_measurement_name;
        materialData.unitOfMeasurementId = material.unit_of_measurement;
      }

      materialData.siteWiseDetails.push({
        site_id: site.site_id,
        site_name: site.site_name,
        quantity: adjustedQuantity,
        amount: site.site_wise_total_amount || 0,
      });

      materialData.totalQuantity += adjustedQuantity;
      materialData.totalAmount += site.site_wise_total_amount || 0;
      materialData.totalQuantityInKG += material.material_total_quantity_by_kg || 0;
      materialData.rfq_material_id = material.rfq_material_id;
    });

    sitedata.push(materialData);
  });

  allData = [
    ...Object.values(aggregatedData).flatMap((subCat) => Object.values(subCat)),
    ...sitedata,
  ];

  setTableData(aggregatedData);
  setAllSiteNames(Array.from(siteNames));
  setSitedata(sitedata);
};

const calculateAdjustedQuantity = (quantity, currentUoM, preferredUoM) => {
  if (currentUoM === "MT" && preferredUoM === "KG") {
    return quantity * 1000;
  } else if (currentUoM === "Bag" && preferredUoM === "KG") {
    return quantity * 50;
  } else if (currentUoM === "Bag" && preferredUoM === "MT") {
    return (quantity * 50) / 1000;
  } else if (currentUoM === "KG" && preferredUoM === "MT") {
    return quantity / 1000;
  } else if (currentUoM === "Cubic Meter" && preferredUoM === "Cubic Meter") {
    return quantity;
  } else if (currentUoM === "Cum." && preferredUoM === "MT") {
    return quantity * 1.6; 
  } else if (currentUoM === "MT" && preferredUoM === "Cum.") {
    return quantity * 0.625; 
  } else if (currentUoM === preferredUoM) {
    return quantity; 
  }
  return quantity; 
};

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const showModalRfq = () => {
    setIsModalOpenRfq(true);
  };
  const handleOkRfq = () => {
    setIsModalOpenRfq(false);
  };
  const handleCancelRfq = () => {
    setIsModalOpenRfq(false);
  };

  let data = null;

  const handleShowHoveredPRDetails = (prNumber, statePRDetails, creator) => {
    setPRNumberHover(prNumber);
    setCreatorHover(creator);
    setStatePRDetailsHover(statePRDetails);
    showModal();
  };
  const handleShowHoveredMaterialWiseDetails = () => {
    showModalRfq();
  };

  const renderTables = () => {
    const subCategoriesArray = Object.keys(tableData);
    return (
      <>
        {subCategoriesArray.map((subCategory, index) => {
          const materialsInSubCategory = Object.values(tableData[subCategory]);
          let customSubcategory = "";
          if (subCategory === "SPECIAL CEMENT") {
            customSubcategory = "Special Cement";
          } else {
            customSubcategory = subCategory;
          }

          const columns = [
            {
              title: "Sr.",
              dataIndex: "sr_no",
              key: "sr_no",
              width: 50,
              render: (text, record, index) => <span>{`${index + 1}`}</span>,
            },
            {
              title: `${customSubcategory}`,
              dataIndex: "purchase_requisition_material_type_name",
              key: "purchase_requisition_material_type_name",
              width: 150,
            },
            ...Array.from(allSiteNames).map((siteName) => ({
              title: `${siteName}`,
              dataIndex: siteName,
              key: siteName,
              width: 150,
              render: (text, record) => {
                const siteQuantity =
                  record.siteWiseQuantities?.[siteName]?.quantity ?? 0;
                const uom = record.siteWiseQuantities?.[siteName]?.uom ?? "";

                if (record.unitOfMeasurement === "Cubic Meter") {
                  return (
                    <div>
                      {siteQuantity.toFixed(2)}
                      <span style={{ marginLeft: "10px" }}>{"Cu. Mtr."}</span>
                    </div>
                  );
                } else {
                  return (
                    <div>
                      {siteQuantity.toFixed(2)}
                      <span style={{ marginLeft: "10px" }}>{uom}</span>
                    </div>
                  );
                }
              },
            })),

            {
              title: "Qty. In Kg",
              dataIndex: "totalQuantityInKG",
              key: "totalQuantityInKG",
              width: 100,
              align: "right",
              render: (text, record) => {
                return (
                  <span>
                    {record.unitOfMeasurement !== "Cubic Meter"
                      ? record.totalQuantityInKG?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })
                      : "-"}
                  </span>
                );
              },
            },
            {
              title: (
                <Tooltip
                  title="Reference price of estimated unit rate comes from material master data"
                  color="#094E8F"
                  placement="top"
                >
                  <span>Est. Unit rate</span>
                </Tooltip>
              ),
              dataIndex: "estimatedMaterialUnitPrice",
              key: "estimatedMaterialUnitPrice",
              width: 120,
              align: "right",
              render: (text, record) => {
                return (
                  <span>
                    {record.estimated_material_unit_price
                      ? `₹ ${record.estimated_material_unit_price?.toLocaleString(
                          "en-IN"
                        )}`
                      : "0"}{" "}
                    {record.unitOfMeasurement === "Cubic Meter"
                      ? "/Cu. Mtr."
                      : "/ Kg"}
                  </span>
                );
              },
            },
            {
              title: "Est. Amount",
              dataIndex: "totalAmount",
              key: "totalAmount",
              width: 120,
              align: "right",
              render: (text, record) => {
                return (
                  <span>
                    {record.totalAmount
                      ? `₹ ${record.totalAmount.toLocaleString("en-IN")}`
                      : "0"}
                  </span>
                );
              },
            },
            {
              title: "Remarks",
              dataIndex: "remarks",
              key: "remarks",
              width: 150,
            },
          ];

          return (
            <div className="PR-body tbl-collapse" key={index}>
              <Collapse
                defaultActiveKey={[index]}
                className="scroll5"
                key={index}
              >
                <Panel header={<Table columns={columns} />} key={index}>
                  <Table
                    columns={columns}
                    dataSource={materialsInSubCategory}
                    pagination={false}
                    scroll={{ x: "max-content" }}
                  />
                </Panel>
              </Collapse>
            </div>
          );
        })}
      </>
    );
  };

  useEffect(() => {
    if (!materialDetails) return;

    const aggregatedData = {};
    const uniqueMasterIds = new Set();

    materialDetails?.material_wise_details?.forEach((material) => {
      uniqueMasterIds.add(material.purchase_requisition_master_id);
    });

    materialDetails?.material_wise_details?.forEach((material) => {
      const subCategory =
        material.purchase_requisition_material_type_sub_category;
      const key = `${subCategory}-${material.purchase_requisition_material_type_name}`;

      if (!aggregatedData[subCategory]) {
        aggregatedData[subCategory] = {};
      }

      if (!aggregatedData[subCategory][key]) {
        aggregatedData[subCategory][key] = {
          purchase_requisition_material_type_name:
            material.purchase_requisition_material_type_name,
          totalQuantity: 0,
          totalAmount: 0,
          estimatedMaterialUnitPrice: material.estimated_material_unit_price,
          siteWiseQuantities: {},

          purchase_requisition_site_name: 562,
          amount: 0,
          id: null,
          material_total_quantity: 0,
          material_total_quantity_by_kg: 0,
          purchase_requisition_material: 1,
          unit_of_measurement: 1,
        };
      }

      material.site_wise.forEach((site) => {
        const siteName = site.site_name;
        const siteQuantity = site.site_wise_total_quantity;

        if (!aggregatedData[subCategory][key].siteWiseQuantities[siteName]) {
          aggregatedData[subCategory][key].siteWiseQuantities[siteName] = {
            quantity: 0,
          };
        }

        aggregatedData[subCategory][key].siteWiseQuantities[
          siteName
        ].quantity += siteQuantity;
        aggregatedData[subCategory][key].totalQuantity += siteQuantity;
        aggregatedData[subCategory][key].totalAmount +=
          site.site_wise_total_amount || 0;

        aggregatedData[subCategory][key].siteWiseQuantities[
          siteName
        ].purchase_requisition_site_name = site.site_id;

        aggregatedData[subCategory][key].siteWiseQuantities[
          siteName
        ].purchase_requisition_site_name = site.site_id;

        aggregatedData[subCategory][key].siteWiseQuantities[
          siteName
        ].material_total_quantity = site.site_wise_total_quantity;

        aggregatedData[subCategory][key].siteWiseQuantities[
          siteName
        ].material_total_quantity_by_kg = site.site_wise_total_quantity_by_kg;
      });
    });

    setAggregateData(aggregatedData);
  }, [materialDetails]);

  useEffect(() => {
    if (materialDetails) {
      const uniqueMasterIds = new Set(
        materialDetails?.material_wise_details?.map(
          (material) => material.purchase_requisition_master_id
        )
      );

      if (uniqueMasterIds.size > 0) {
        setIfMultipleMasterId(Array.from(uniqueMasterIds));
      }
    }
  }, [materialDetails]);

  const createPayloadFromMaterialDetails = (siteData) => {
    const payload = {
      rfq_master: materialDetails.rfq_details[0].id || null,
      rfq_site_details: [],
    };

    const siteGroupedData = {};

    siteData.forEach((material) => {
      const {
        material_type_name,
        material_type_sub_category,
        unitOfMeasurement,
        totalQuantity,
        totalAmount,
        totalQuantityInKG,
        siteWiseDetails,
        purchase_requisition_material_id,
        estimated_material_unit_price,
        rfq_material_id,
      } = material;

      if (material.unitOfMeasurement === "Cubic Meter") {
        siteWiseDetails.forEach((site) => {
          const { site_id, quantity, amount } = site;

          if (!siteGroupedData[site_id]) {
            siteGroupedData[site_id] = {
              purchase_requisition_site_name: site_id,
              rfq_material_details: [],
            };
          }

          siteGroupedData[site_id].rfq_material_details.push({
            id: rfq_material_id ? rfq_material_id : null,
            material_total_quantity: totalQuantity || 0,
            material_total_quantity_by_kg: totalQuantityInKG || 0,
            amount: totalAmount || 0,
            estimated_material_unit_price: estimated_material_unit_price || 0,
            purchase_requisition_material: purchase_requisition_material_id,
            unit_of_measurement: 4,
          });
        });
      } else {
        siteWiseDetails.forEach((site) => {
          const { site_id, quantity, amount } = site;

          if (!siteGroupedData[site_id]) {
            siteGroupedData[site_id] = {
              purchase_requisition_site_name: site_id,
              rfq_material_details: [],
            };
          }

          siteGroupedData[site_id].rfq_material_details.push({
            id: rfq_material_id ? rfq_material_id : null,
            material_total_quantity:
              totalQuantityInKG / 1000 === quantity
                ? totalQuantityInKG / 1000
                : totalQuantityInKG / 50 || 0,
            material_total_quantity_by_kg: totalQuantityInKG || 0,
            amount: amount || 0,
            purchase_requisition_material: purchase_requisition_material_id,
            unit_of_measurement: totalQuantityInKG / 1000 === quantity ? 1 : 3,
          });
        });
      }
    });

    payload.rfq_site_details = Object.values(siteGroupedData);

    return payload;
  };

  const handleSubmit = async (rfqId) => {
    try {
      setBtnLoading(true);

      const payload = createPayloadFromMaterialDetails(sitedata);

      let response;
      if (rfqMaterialDetailsID === false) {
        response = await postRequest("rfq-material-details/", payload);
      } else {
        response = await patchRequest(
          `rfq-material-details/${rfqId}/`,
          payload
        );
      }

      if (response.data.success) {
        setBtnLoading(false);
        navigate(`/request-for-quotation/select-vendor/${rfqId}`);
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Select Vendor</h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/request-for-quotation/history">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {" "}
                <Link to={`/request-for-quotation/add-rfq/${responseId}`}>
                  Add RFQ
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Select Vendor</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <h5
            className="rfq-number new"
            style={{ display: "inline-flex", alignItems: "center" }}
          >
            PR Number :{" "}
            {prNumberList.map((prNumber, index) => {
              return (
                <>
                  <span
                    key={index}
                    onMouseEnter={() => {
                      handleShowHoveredPRDetails(
                        prNumber?.pr_number,
                        prNumber?.data,
                        prNumber?.pr_creator
                      );
                    }}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    {prNumber?.pr_number}
                    <InfoCircleOutlined
                      style={{
                        color: "#094E8F",
                        marginLeft: "3px",
                        background: "none",
                        paddingRight: "0",
                        padding: "0px",
                      }}
                    />
                  </span>
                </>
              );
            })}
          </h5>
        </div>
      </div>
      <div className="stepscontentwrap">
        <div className="stepsContent">
          <section className="grid-sec mt-5 tablegridsec">
            <Spin spinning={apiLoading}>
            <div className="PR-body " style={{ padding: "0" }}>
              <Row gutter={16} style={{ marginBottom: "10px" }}>
                <Col className="TextFeild gutter-row">
                  <h5 className="rfq-number new">
                    RFQ Number : <span>{rfqNumber}</span>
                  </h5>
                </Col>
                <Col className="TextFeild gutter-row">
                  <h5
                    className="rfq-number new"
                    onMouseEnter={() => {
                      handleShowHoveredMaterialWiseDetails();
                    }}
                  >
                    Material Wise{" "}
                    <InfoCircleOutlined
                      style={{ color: "#094E8F", marginLeft: "3px" }}
                    />
                  </h5>
                </Col>
              </Row>

              {view === "City Wise" ? (
                <CityWiseView response={RFQMaterialDetails} uomList={uomList} />
              ) : (
                <>
                  <div className="tablewrp" style={{ padding: "0" }}>
                    {renderTables()}
                  </div>
                  <div
                    className="FormFooter bidftr"
                    style={{
                      padding: "16px  ",
                      paddingBottom: "0",
                      margin: "0",
                    }}
                  >
                    <ButtonField
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Previous"
                      label="Previous"
                      onClick={() =>
                        navigate(`/request-for-quotation/add-rfq/${responseId}`)
                      }
                    />
                    <ButtonField
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="submit"
                      label="Select Vendor"
                      onClick={() => handleSubmit(state.rfqId)}
                      loading={btnLoading}
                    />
                  </div>
                </>
              )}
            </div>
            </Spin>
          </section>
        </div>
      </div>
      <Modal
        className="ModelPopupSecPopUpPRDetails"
        title={
          <div style={{ justifyItems: "center" }}>
            <h5 className="rfq-number new">
              PR Number : <span>{prNumberHover}</span>
              PR Creator : <span>{prCreatorHover}</span>
            </h5>
          </div>
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        closable={handleCancel}
        keyboard={true}
        width={"90%"}
      >
        <PRPopUpDetails statePRDetails={statePRDetailsHover} />
      </Modal>
      <Modal
        className="ModelPopupSecPopUpPRDetails"
        title="RFQ - Material Details (Material Wise)"
        open={isModalOpenRfq}
        onOk={handleOkRfq}
        onCancel={handleCancelRfq}
        closable
        keyboard
        width="90%"
      >
        <>
          <section className="grid-sec mt-5">
            <Spin spinning={apiLoading}>
              <div className="PR-body" style={{ padding: "0" }}>
                <>{renderTables()}</>
              </div>
            </Spin>
          </section>
        </>
      </Modal>
    </>
  );
};
export default RFQMaterialDetails;
